// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1ukxx","errorLogs":"styles_errorLogs__3GpkG"};